export const LOCAL_STORAGE_ID = 'filterOptionsRelatorioCotasCliente'
